/**
 * @fileoverview O convite aberto na aba (etapa 5 dos planos): o código sai do
 * endereço ao abrir o link e fica guardado só nesta aba (sessionStorage), para
 * recarregar a página. Sai quando o convite é usado, não vale mais ou a pessoa
 * diz "Agora não". Quem foi ao login pelo convite ("Entrar para aceitar") volta
 * para ele depois de entrar, uma vez: os outros logins da aba seguem o caminho
 * de sempre.
 */

const KEY = "sttelar:pending-invite";
const RETURN_KEY = "sttelar:pending-invite-return";
const CODE_RE = /^[0-9a-f]{64}$/;

export const keepPendingInvite = (code) => {
  try {
    sessionStorage.setItem(KEY, code);
  } catch (err) {
    // Sem o armazenamento do navegador, a pessoa abre o link do e-mail de novo.
  }
};

export const readPendingInvite = () => {
  try {
    const code = sessionStorage.getItem(KEY);
    return code && CODE_RE.test(code) ? code : null;
  } catch (err) {
    return null;
  }
};

export const clearPendingInvite = () => {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(RETURN_KEY);
  } catch (err) {
    // Nada guardado.
  }
};

export const markInviteReturn = () => {
  try {
    sessionStorage.setItem(RETURN_KEY, "1");
  } catch (err) {
    // Sem o armazenamento do navegador, a pessoa abre o link do e-mail de novo.
  }
};

/** O login de agora volta ao convite? Responde uma vez (a marca sai ao ler). */
export const takeInviteReturn = () => {
  try {
    const marked = sessionStorage.getItem(RETURN_KEY) === "1";
    sessionStorage.removeItem(RETURN_KEY);
    return marked;
  } catch (err) {
    return false;
  }
};
